import Vue from 'vue'
import Vuex from 'vuex'
import pinnedUser from './modules/pinnedUser.js'
import currentUser from './modules/currentUser.js'
import createPersistedState from "vuex-persistedstate";
import groupFormState from './modules/groupFormState'
import tileLayout from './modules/tileLayout'
import practiceDashboardTileLayout from './modules/tileLayout'
import userDashboardTileLayout from './modules/tileLayout'
import notificationBus from './modules/notificationBus'
import patientInteractionTimer from './modules/patientInteractionTimer'
import createMutationSharer from 'vuex-shared-mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    pinnedUser,
    currentUser,
    groupFormState,
    tileLayout,
    practiceDashboardTileLayout,
    userDashboardTileLayout,
    notificationBus,
    patientInteractionTimer
  },
  plugins: [
    createPersistedState(),
    createMutationSharer({
      predicate: [
        'notificationBus/standAloneProgressNoteSaved',
        'patientInteractionTimer/incrementProgressNotesSaved'
      ]
    })
  ],
})
